<template>
  <v-app>
    <v-main class="login_background">
      <card-login title="Cadastrar">
        <template v-slot:form>
          <div class="title text-center">Crie sua conta</div>
          <form-register :formData.sync="user" ref="form"></form-register>
        </template>
        <template v-slot:control>
          <v-row>
            <v-col>
              <div class="d-flex justify-center">
                <!-- Component obrigatorio - Botão de login  -->
                <v-btn min-width="200px" :loading="loading" rounded x-large color="primary" @click="clickSubmit">Cadastrar</v-btn>
                <!-- ....................................... -->
              </div>
            </v-col>

            <v-col cols="12">
              <!--  -->
              <div class="d-flex justify-center">
                <v-btn small text color="primary" rounded to="/login">Voltar</v-btn>
              </div>
              <!-- Component obrigatorio - Botão de login  -->
              <!-- ....................................... -->
              <!--  -->
            </v-col>
          </v-row>
        </template>
      </card-login>
    </v-main>
    <v-dialog
      max-width="600"
      v-model="access_key_dialog"
      persistent
    >
      <template v-slot:default="dialog">
        <v-card>
          <v-card-text>
            <div class="text-h5 pa-12">Precisamos que informe sua chave de acesso para continuar</div>
            <v-form
              ref="formAccessKey"
              v-model="valid"
              :lazy-validation="lazy"
            >
              <v-text-field
                v-model="access_key"
                id="access_key"
                label="Chave de acesso"
                name="access_key"
                type="access_key"
                :rules="required_access_key"
              />
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
              text
              to="/login"
            >Voltar</v-btn>
            <v-btn
              :disabled="access_key == null"
              color="success"
              text
              @click="checkAccessKey"
            >
              <v-icon left>
                mdi-check
              </v-icon>
              Enviar
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <dialog-login-error v-if="show_dialog_error" :error_msg="error_msg" @close="show_dialog_error=false"></dialog-login-error>
  </v-app>
</template>

<script>
import validations from "@/mixins/validations";
export default {
  name: "Register",
  mixins: [validations],
  components: {
    CardLogin: () => import("@/_auth/components/containers/_auth_card_01.vue"),
    FormRegister: () => import("@/_auth/components/forms/Signup.vue"),
    DialogLoginError: () => import('../components/DialogLoginError.vue'),
  },
  data() {
    return {
      lazy: false,
      valid: false,
      user: {
        name: null,
        email: null,
        password: null,
        password_confirmation: null
      },
      loading: false,
      timeout: 1000,
      access_key_dialog: false,
      show_dialog_error: false,
      error_msg: null,
      access_key: null,
    };
  },
  methods: {
    checkAccessKey(){
      if(this.$refs.formAccessKey.validate()){
        this.access_key_dialog = false;
        this.$sweetAlerts.toast1("success", "Cadastro liberado!");
      }else{
        this.$sweetAlerts.toast1("error", "Chave de acesso recusada!");
      }
    },
    handleClose(){
      this.error_msg = null
      this.show_dialog_error = false
    },
    clickSubmit() {
      this.loading = true;
      setTimeout(() => {
        if (this.$refs.form.validateForm() && this.$refs.formAccessKey.validate()) {
          this.submitRegister().then(() => {
            this.loading = false;
          });
        } else {
          if(this.$refs.formAccessKey.validate() == false){
            this.$sweetAlerts.toast1("error", "Chave de acesso recusada!");
          }
          this.loading = false;
        }
      }, this.timeout);
    },
    submitRegister() {
      return this.$auth
        .register({
          params: {
            name: this.user.name,
            email: this.user.email,
            password: this.user.password,
            password_confirmation: this.user.password_confirmation,
            confirm_success_url: origin // "http://localhost:8080/"
          }
        })

        .then(response => {
          if (response.headers["access-token"]) {
            const token = [
              response.headers["token-type"],
              response.headers["access-token"],
              response.headers.client,
              response.headers.uid,
              response.headers.expiry
            ].join("|");
            localStorage.auth_token_default = token;
            this.show_dialog_error = true
          }
          this.$sweetAlerts.toast1("success", "E-mail de confirmação enviado!");
        })

        .catch(error => {
          console.log("Erro na tentativa de fazer cadastro..", error);
          this.$sweetAlerts.toast1("error", "Algo deu errado!");
          if (error && error.response && error.response.data && error.response.data.errors){
            let err = error.response.data.errors.full_messages[0]

            this.error_msg = err
            this.show_dialog_error = true
          }
        });
    }
  },
  mounted() {
    this.access_key_dialog = true
  },
};
</script>

<style>
.login_background {
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: center !important;
  background: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .4)), url('../../assets/login_background.png');
  /* background: url('../../assets/background_login.jpg') */
}
</style>
